var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.22,10.22A.75.75,0,0,0,1.28,11.28l5-5a.75.75,0,0,0,0-1.061l-5-5A.75.75,0,0,0,.22,1.28l4.47,4.47Z","transform":"translate(9.25 6.25)","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","data-name":"24x24/On Light/Arrow-Right"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
